import { useTenantContext } from "../tenant/TenantProvider";

/** The current site's tenant settings (branding, features, signup rules), loaded once at boot. */
export const useTenantConfig = () => useTenantContext();
